import * as types from './mutation-types'

export default {
  [types.SET_SNACKBAR](state, payload) {
    state.snackbars.push(payload); // = state.snackbars.concat(payload);
  },
  [types.REMOVE_SNACKBAR](state) {
    //console.log(payload);
    //payload.showing = false;
    state.snackbars.pop();
  },
}